import * as z from "zod";

const pukNumber = z.object({
  name: z.string().optional(),
  value: z.string().optional(),
});

const simCardList = z.object({
  cardCharacteristics: z.array(pukNumber),
  cardIccid: z.string(),
});

export const serverResponse = z.array(simCardList);
export type IPukNumber = z.infer<typeof pukNumber>;
